import LogRocket from 'logrocket';

type LogRocketEvent = 'NavigateToBuilder' | 'NavigateToDashboard';

export const safeLogRocketTrack = (event: LogRocketEvent, isHipaa: boolean = false) => {
  if (import.meta.env.PUBLIC_LOGROCKET_APP_ID && !isHipaa) {
    LogRocket.track(event);
  }
};
